import { Box, Typography, Image, Flex, MediaBox } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { Section } from "@jewlr/storybook/info"
import StyledLink from "components/landing/link"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

import { protectionPlanData } from "./data"

const Plan = styled(Flex).attrs({
  mx: "auto",
  width: "110px",
})`
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-evenly;
  margin-top: -4px;
  padding: 16px 2px 2px;
  text-align: center;
  transition: all 0.2s;
`
const PlanLabel = styled(Typography).attrs((props) => ({
  mx: "auto",
  width: "90px",
  ...props,
}))`
  background-color: ${(props) => props.theme.colors.selected};
  color: white;
  text-align: center;
  font-size: 15px;
  height: 22px;
  padding-top: 2px;
  position: relative;
  :after {
    position: absolute;
    display: block;
    content: " ";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${(props) => props.theme.colors.selected};
    left: 37px;
    margin-top: 1px;
    ${(props) => props.theme.mediaQueries.tablet`
     left: 34px;
  `}
  }
`

const ProtectionCoverageExample = () => (
  <Box>
    <Box
      margin="auto"
      pb={{ _: 4, tablet: 6 }}
      pt={{ _: 4, tablet: 0 }}
      textAlign="center"
      width={{ _: "79%", desktop: "50%", tablet: "72%" }}
    >
      <Typography mb={2}>
        Jewlr has partnered with Extend to provide peace-of-mind protection for
        the {jewlr_t("terms.jewelry")}{" "}
        {sl.config.enable_watches && "and watches"} you love.
      </Typography>
      <Typography>
        Extend bundles your personalized pieces with an affordable protection
        plan which you add to your purchase during checkout – so your{" "}
        {jewlr_t("terms.jewelry")} is covered, even after the manufacturer’s
        warranty expires.
      </Typography>
    </Box>
    <Section
      bg="#EFF1F0"
      mb={8}
      mx={{ _: 2, tablet: 0 }}
      px={2}
      py={{ _: 4, tablet: 0 }}
      textAlign="center"
    >
      <Box
        alignItems="center"
        display={{ _: "block", tablet: "flex" }}
        flexWrap="wrap"
        gutter={{ tablet: 1 }}
        justifyContent="space-between"
        mb={{ tablet: 8 }}
      >
        <MediaBox flex={1} greaterThanOrEqual="tablet" textAlign="right">
          <Image
            alt="Protection Coverage"
            height={{ desktop: "400px", tablet: "258px" }}
            src={require("images/info/warranty/protection_coverage_example.png")}
            width={{ desktop: "480px", tablet: "310px" }}
          />
        </MediaBox>
        <Box flex={1}>
          <Typography bold fontSize={18} pb={2}>
            {jewlr_t("terms.Jewelry")} Protection
            <Box as="br" display={{ tablet: "none" }} /> Coverage Example
          </Typography>
          <Flex
            alignItems="flex-start"
            gutter={{ _: "4px", tablet: 1 }}
            justifyContent="center"
            pb={2}
          >
            {protectionPlanData().map((plan, index) => (
              <Box key={index}>
                {plan.label === null ? (
                  <Box height={{ _: "22px", tablet: "22px" }} />
                ) : (
                  <PlanLabel>{plan.label}</PlanLabel>
                )}

                <Plan>
                  <Image
                    alt="Extend Warranty"
                    height="35px"
                    mb="4px"
                    src={require("images/info/warranty/extend_icon.svg")}
                    title="Extend Warranty"
                    width="33px"
                  />
                  <Typography fontWeight="700">{plan.year}</Typography>
                  <Typography>Protection Plan</Typography>
                  <Typography mb={1}>
                    {to_currency(plan.price, { precision: 2 })}
                    <a href="#plan-pricing">*</a>
                  </Typography>
                </Plan>
              </Box>
            ))}
          </Flex>
          <StyledLink
            style={{ color: "primary", fontSize: 15, fontWeight: 300 }}
            type="underline"
            url={`/${jewlr_t("terms.personalized")}-${jewlr_t(
              "terms.jewelry"
            )}-landing`}
          >
            Shop All {jewlr_t("terms.Jewelry")}
          </StyledLink>
        </Box>
      </Box>
    </Section>
  </Box>
)

export default ProtectionCoverageExample
